import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface LinkProps {
    to: string;
    label: React.ReactNode;
    icon: React.ReactNode;
    disabled?: boolean;
    className?: string;
    collapse: boolean;
    sub?: boolean;
}

const MenuLink: React.FC<LinkProps> = ({ to, label, icon, disabled, className, collapse, sub = false }) => {
    const [show, setShow] = React.useState<boolean>(false);
    return (
        <li className={`relative ${disabled ? 'pointer-events-none opacity-25' : ''}`} onMouseEnter={() => collapse && setShow(true)} onMouseLeave={() => collapse && setShow(false)}>
            <RouterLink to={to} className={`flex gap-2 items-center text-white h-[2.375rem] pl-[0.938rem] focus:bg-transparent focus:text-white transition-all outline-none hover:bg-[#2020324D] group ${className}`}>
                {icon &&
                    <div className='flex justify-center items-center w-[1.675rem]' >
                        {icon}
                    </div>
                }
                {(!collapse || sub) && <span className="ml-0 transition-all group-hover:ml-1 text-[0.875rem]">{label}</span>}
                {(collapse && show && !sub) && <div className={`absolute z-50 w-[14.6rem] bg-slate-800 rounded-sm z-1 mx-2 p-2 shadow-sm left-[40px]`}>{label}</div>}
            </RouterLink>
        </li>
    );
};

export default MenuLink;